if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((thumbnail) => {
            thumbnail.querySelector('button')?.addEventListener(
              'click',
              this.setActiveMedia.bind(
                this,
                thumbnail.dataset.target,
                false
              )
            );
          });

        if (
          this.dataset.desktopLayout?.includes('thumbnail') &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const current = event.detail?.currentElement;

        if (!current || !this.elements.thumbnails) return;

        this.setActiveThumbnail(
          this.elements.thumbnails.querySelector(
            `[data-target="${current.dataset.mediaId}"]`
          )
        );
      }

      setActiveMedia(mediaId, prepend) {
        if (!this.elements.viewer) return;

        const usesColorFilter = !!this.closest('product-info')
          ?.querySelector('reguero-color-gallery');

        if (usesColorFilter) prepend = false;

        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${mediaId}"]:not(.reguero-color-hidden)`
          ) ||
          this.elements.viewer.querySelector(
            '[data-media-id]:not(.reguero-color-hidden)'
          );

        if (!activeMedia) return;

        const activeId = activeMedia.dataset.mediaId;

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.toggle(
              'is-active',
              element === activeMedia
            );
          });

        if (prepend) {
          if (
            activeMedia.parentElement.firstElementChild !== activeMedia
          ) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          const thumbnail = this.elements.thumbnails?.querySelector(
            `[data-target="${activeId}"]`
          );

          if (
            thumbnail &&
            thumbnail.parentElement.firstElementChild !== thumbnail
          ) {
            thumbnail.parentElement.prepend(thumbnail);
          }

          this.elements.viewer.resetPages?.();
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!activeMedia.isConnected) return;

          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
              behavior: usesColorFilter ? 'instant' : 'auto',
            });
          }

          // Color changes should not move the page vertically.
          if (usesColorFilter) return;

          const rect = activeMedia.getBoundingClientRect();

          if (rect.top > -0.5) return;

          window.scrollTo({
            top: rect.top + window.scrollY,
            behavior: 'smooth',
          });
        });

        this.playActiveMedia(activeMedia);

        const thumbnail = this.elements.thumbnails?.querySelector(
          `[data-target="${activeId}"]`
        );

        this.setActiveThumbnail(thumbnail);

        if (thumbnail) {
          this.announceLiveRegion(
            activeMedia,
            thumbnail.dataset.mediaPosition
          );
        }
      }

      setActiveThumbnail(thumbnail) {
        if (
          !this.elements.thumbnails ||
          !thumbnail ||
          thumbnail.classList.contains('reguero-color-hidden')
        ) {
          return;
        }

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((button) => button.removeAttribute('aria-current'));

        thumbnail.querySelector('button')
          ?.setAttribute('aria-current', 'true');

        if (
          this.elements.thumbnails.isSlideVisible?.(thumbnail, 10)
        ) {
          return;
        }

        this.elements.thumbnails.slider?.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );

        if (!image || !this.elements.liveRegion) return;

        const announce = () => {
          const message =
            window.accessibilityStrings?.imageAvailable;

          if (!message) return;

          this.elements.liveRegion.setAttribute('aria-hidden', 'false');
          this.elements.liveRegion.textContent =
            message.replace('[index]', position);

          window.clearTimeout(this.announcementTimer);

          this.announcementTimer = window.setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', 'true');
          }, 2000);
        };

        if (image.complete) {
          announce();
        } else {
          image.addEventListener('load', announce, { once: true });
        }
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia?.();
        activeItem.querySelector('.deferred-media')?.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector('sticky-header');

        this.stickyHeader?.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute('role', 'presentation');

        this.elements.viewer.sliderItems.forEach((slide) => {
          slide.setAttribute('role', 'presentation');
        });
      }
    }
  );
}